import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { API_GET_OPEN, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import { toast } from "react-toastify";
// import apiEndpoints from "../../../Common/Api/apiEndpoints";
// import { toast } from "react-toastify";

const ContactUs = () => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      phno: "",
      email: "",
      address: "",
      insta: "",
      tiktok: "",
      facebook: "",
    },
    validationSchema: yup.object({
      phno: yup
        .string()
        .min(10, "Minimum 10 digits")
        .max(25, "Max 25 digits")
        .required("Required."),
      insta: yup.string().required("Required"),
      tiktok: yup.string().required("Required"),
      facebook: yup.string().required("Required"),
      email: yup
        .string()
        .matches(emailRegex, "Invalid email")
        .required("Required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try
      {
        setLoading(true);
        const res = await API_POST(API_endspoints.updatefootercontent, values);
        if (res.s)
        {
          toast.success("Updated Successfully");
        }
        setLoading(false);
        handleData();
      } catch (error)
      {
        setLoading(false);
        console.log(error);
      } finally
      {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const handleData = async () => {
    try
    {
      setLoading(true);
      let res = await API_GET_OPEN(API_endspoints.getfootercontent);
      res?.s && formik.setValues(res?.r);
      setLoading(false);
    } catch (error)
    {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    handleData();
  }, []);

  return (
    <>
      {loading ? (
        <Box className="flexCenter" sx={{ height: "calc(100vh - 200px)" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: "1440px",
            // background:'#fff',
            border: "1px solid #fff",
            borderRadius: "15px",
            boxShadow: "1px 1px 5px grey",
            p: 3,
            py: 4,
            height: "calc(100vh - 220px)",
            overflow: "auto",
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: { md: "2rem" },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box sx={{ width: "100%" }}>
                <label htmlFor="mobile_number">Mobile number</label>
                <TextField
                  type="tel"
                  id="phno"
                  name="phno"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phno}
                  error={formik.touched.phno && Boolean(formik.errors.phno)}
                  helperText={formik.touched.phno && formik.errors.phno}
                  variant="outlined"
                  fullWidth
                  focused
                  sx={{
                    margin: "0.5rem 0 1rem 0",
                    ".MuiInputBase-root": {
                      borderRadius: "11px",
                      // background: "#EAE8FF24",
                      background: "#fff",
                      color: "#000",
                    },
                    ".MuiInputBase-root:hover": {
                      background: "#F57C00",
                      color: "#fff",
                    },

                    ".MuiOutlinedInput-input:focus": {
                      outline: "none",
                    },
                    fieldset: {
                      border: "none",
                    },
                  }}
                  placeholder="Contact number"
                />
              </Box>
              <Box sx={{ width: "100%" }}>
                <label htmlFor="email">Email Address</label>
                <TextField
                  type="email"
                  id="email"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  variant="outlined"
                  fullWidth
                  focused
                  sx={{
                    margin: "0.5rem 0 1rem 0",
                    ".MuiInputBase-root": {
                      borderRadius: "11px",
                      // background: "#EAE8FF24",
                      background: "#fff",
                      color: "#000",
                    },
                    ".MuiInputBase-root:hover": {
                      background: "#F57C00",
                      color: "#fff",
                    },

                    ".MuiOutlinedInput-input:focus": {
                      outline: "none",
                    },
                    fieldset: {
                      border: "none",
                    },
                  }}
                  placeholder="Enter your email"
                />
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: { md: "2rem" },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  // gap: { md: "2rem" },
                  flexDirection: { xs: "column" },
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <label htmlFor="insta">Instagram link</label>
                  <TextField
                    type="text"
                    id="insta"
                    name="insta"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.insta}
                    error={formik.touched.insta && Boolean(formik.errors.insta)}
                    helperText={formik.touched.insta && formik.errors.insta}
                    variant="outlined"
                    fullWidth
                    focused
                    sx={{
                      margin: "0.5rem 0 1rem 0",
                      ".MuiInputBase-root": {
                        borderRadius: "11px",
                        // background: "#EAE8FF24",
                        background: "#fff",
                        color: "#000",
                      },
                      ".MuiInputBase-root:hover": {
                        background: "#F57C00",
                        color: "#fff",
                      },

                      ".MuiOutlinedInput-input:focus": {
                        outline: "none",
                      },
                      fieldset: {
                        border: "none",
                      },
                    }}
                    placeholder="Enter social link"
                  />
                </Box>

                {/* <Box sx={{ width: "100%" }}>
                  <label htmlFor="twitter">Twitter link</label>
                  <TextField
                    type="text"
                    id="twitter"
                    name="twitter"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.twitter}
                    error={
                      formik.touched.twitter && Boolean(formik.errors.twitter)
                    }
                    helperText={formik.touched.twitter && formik.errors.twitter}
                    variant="outlined"
                    fullWidth
                    focused
                    sx={{
                      margin: "0.5rem 0 1rem 0",
                      ".MuiInputBase-root": {
                        borderRadius: "11px",
                        // background: "#EAE8FF24",
                        background: "#fff",
                        color: "#000",
                      },
                      ".MuiInputBase-root:hover": {
                        background: "#F57C00",
                        color: "#fff",
                      },

                      ".MuiOutlinedInput-input:focus": {
                        outline: "none",
                      },
                      fieldset: {
                        border: "none",
                      },
                    }}
                    placeholder="Enter social link"
                  />
                </Box> */}
                <Box sx={{ width: "100%" }}>
                  <label htmlFor="facebook">Facebook link</label>
                  <TextField
                    type="text"
                    id="facebook"
                    name="facebook"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.facebook}
                    error={
                      formik.touched.facebook && Boolean(formik.errors.facebook)
                    }
                    helperText={
                      formik.touched.facebook && formik.errors.facebook
                    }
                    variant="outlined"
                    fullWidth
                    focused
                    sx={{
                      margin: "0.5rem 0 1rem 0",
                      ".MuiInputBase-root": {
                        borderRadius: "11px",
                        // background: "#EAE8FF24",
                        background: "#fff",
                        color: "#000",
                      },
                      ".MuiInputBase-root:hover": {
                        background: "#F57C00",
                        color: "#fff",
                      },

                      ".MuiOutlinedInput-input:focus": {
                        outline: "none",
                      },
                      fieldset: {
                        border: "none",
                      },
                    }}
                    placeholder="Enter social link"
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <label htmlFor="tiktok">Tiktok link</label>
                  <TextField
                    type="text"
                    id="tiktok"
                    name="tiktok"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.tiktok}
                    error={
                      formik.touched.tiktok && Boolean(formik.errors.tiktok)
                    }
                    helperText={
                      formik.touched.tiktok && formik.errors.tiktok
                    }
                    variant="outlined"
                    fullWidth
                    focused
                    sx={{
                      margin: "0.5rem 0 1rem 0",
                      ".MuiInputBase-root": {
                        borderRadius: "11px",
                        // background: "#EAE8FF24",
                        background: "#fff",
                        color: "#000",
                      },
                      ".MuiInputBase-root:hover": {
                        background: "#F57C00",
                        color: "#fff",
                      },

                      ".MuiOutlinedInput-input:focus": {
                        outline: "none",
                      },
                      fieldset: {
                        border: "none",
                      },
                    }}
                    placeholder="Enter link"
                  />
                </Box>
              </Box>
              <Box sx={{ width: "100%" }}>
                <label htmlFor="address"> Address</label>
                <TextField
                  type="text"
                  id="address"
                  name="address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                  error={
                    formik.touched.address && Boolean(formik.errors.address)
                  }
                  helperText={formik.touched.address && formik.errors.address}
                  variant="outlined"
                  fullWidth
                  focused
                  multiline
                  rows={5.5}
                  sx={{
                    margin: "0.5rem 0 1rem 0",
                    ".MuiInputBase-root": {
                      borderRadius: "11px",
                      background: "#fff",
                      color: "#000",
                    },
                    ".MuiInputBase-root:hover": {
                      background: "#F57C00",
                      color: "#fff",
                    },
                    ".MuiOutlinedInput-input:focus": {
                      outline: "none",
                    },
                    fieldset: {
                      border: "none",
                    },
                  }}
                  placeholder="Enter your address"
                />
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "1rem",
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  backgroundColor: "#164FA1",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#164FA1",
                    color: "white",
                  },
                }}
                type="submit"
                onClick={formik.handleSubmit}
              >
                Submit
              </Button>
            </Box>
          </form>
        </Box>
      )}
    </>
  );
};

export default ContactUs;
